import React from 'react';
import { Field, inputClasses } from './Field';
interface PercentFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
}
export function PercentField({
  id,
  label,
  value,
  onChange,
  required,
  error,
  hint,
  className
}: PercentFieldProps) {
  return <Field id={id} label={label} required={required} error={error} hint={hint} className={className} data-id="element-105" data-mp="1o51y16lwv5pq">
      <div className="relative" data-id="element-106" data-mp="1t225nlyesgiy">
        <input id={id} name={id} type="text" inputMode="decimal" autoComplete="off" value={value} placeholder="0" aria-required={required} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} onChange={e => onChange(e.target.value)} className={inputClasses(Boolean(error), 'numeric pr-8 text-right')} data-id="element-107" data-mp="1xubq4mgr8odu" />
        <span aria-hidden="true" className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-ink-400" data-id="element-108" data-mp="tttnlod8mhnz">
          %
        </span>
      </div>
    </Field>;
}